import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { generalService } from './general.service';

@Injectable()
export class EditUnitSatService {
  public matOptions: any;
  private matOptionsSubject = new Subject<any>();
  matOptions$ = this.matOptionsSubject.asObservable();

  constructor(private _generalService: generalService) { this.matOptions = new Object();}

  consultSATunit() {
    this._generalService.metodoCall('itemCodeSAT/consultItemSATunits')
    .subscribe(SATunits => {
      SATunits = JSON.parse(SATunits);
      this.matOptions.SATunits = SATunits;
      this.emitMatOptions();
    });

  }

  emitMatOptions(){
    this.matOptionsSubject.next(this.matOptions);
  }
  
}



// WEBPACK FOOTER //
// ./src/app/services/edit-unit-sat.service.ts